/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import Grid from 'apollo-react/components/Grid';
import Info from 'apollo-react-icons/Info';
import StatusCheck from 'apollo-react-icons/StatusCheck';
import StatusExclamation from 'apollo-react-icons/StatusExclamation';
import StatusNegative from 'apollo-react-icons/StatusNegative';
import React from 'react';

const VARIANT_BG_COLORS = {
  error: '#e20000',
  warning: '#ff9300',
  info: '#fff',
  success: '#00c221',
};

const VARIANT_FONT_COLORS = {
  error: '#fff',
  warning: '#fff',
  info: '#000',
  success: '#fff',
};

const VARIANT_ICONS = {
  error: StatusNegative,
  warning: StatusExclamation,
  info: Info,
  success: StatusCheck,
};

const BannerCard = ({ message, variant, onClick = () => {}, messageProps = {}, ...otherProps }) => {
  const Icon = VARIANT_ICONS[variant];
  const backgroundColor = VARIANT_BG_COLORS[variant];
  const color = VARIANT_FONT_COLORS[variant];

  return (
    <Card style={{ backgroundColor, color, overflow: 'auto', padding: '10px 0' }} {...otherProps}>
      <CardContent>
        <Grid container alignItems="center" spacing={1}>
          <Grid item xs={2}>
            <Icon />
          </Grid>
          <Grid item xs={10}>
            <div
              onClick={onClick}
              style={{ cursor: 'pointer', overflowWrap: 'break-word' }}
              {...messageProps}
            >
              {message}
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default BannerCard;
